module.exports = __webpack_public_path__ + "static/img/screenshots-ios.794a1b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/images/screenshots-ios.png
// module id = za/q
// module chunks = 26